<script>
import SignupLayout from '@/layouts/SignupLayout';
import ParticipantSignup from '@/components/ParticipantSignup';
import ResearcherSignup from '@/components/ResearcherSignup';
import { AccountTypes } from '@/constants';

const { researcher, participant } = AccountTypes;

export default {
  components: {
    ParticipantSignup,
    ResearcherSignup,
    SignupLayout,
  },
  props: {
    as: {
      type: String,
      default: participant,
    },
  },
  data() {
    return {
      accountTypes: [participant, researcher],
      signupAs: [participant, researcher].includes(this.as)
        ? this.as
        : participant,
    };
  },
  computed: {
    signupFormComponent() {
      return `${this.signupAs}-signup`;
    },
    callToActionText() {
      if (this.signupAs === researcher) {
        return 'Trusted by the world-class research teams';
      }

      return 'Help shape world-class products';
    },
  },
  methods: {
    toggleSignupAs() {
      const next = this.signupAs === researcher ? participant : researcher;
      this.$router.push({ query: { signupAs: next } });
      this.signupAs = next;
    },
  },
};
</script>

<template>
  <signup-layout :call-to-action-text="callToActionText" :signup-as="signupAs">
    <v-tabs :value="accountTypes.indexOf(signupAs)" @change="toggleSignupAs">
      <v-tab
        v-for="(accountType, idx) in accountTypes"
        :key="accountType"
        :class="idx === 0 ? 'mr-13' : ''"
      >
        I'm a {{ accountType | capitalize }}
      </v-tab>
    </v-tabs>
    <!-- eslint-disable vue/require-component-is -->
    <component :is="signupFormComponent" />
  </signup-layout>
</template>

<style scoped>
.v-tabs {
  margin-bottom: 20px;
}

.v-slide-group__prev {
  display: none !important;
}

.v-tab {
  letter-spacing: initial;
}
</style>
